import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { publicApi } from '../api';
import { Gamepad2, Bell, CheckCircle2 } from 'lucide-react';
import { toast } from '../hooks/use-toast';
import { upcomingProducts } from '../mock';
import UpcomingProductCard from '../components/UpcomingProductCard';

const Shop = () => {
  const [flavors, setFlavors] = useState([]);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    publicApi.getProducts().then(setFlavors).catch(() => setFlavors([]));
  }, []);

  const notify = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubscribed(true);
    toast({ title: "You're on the list!", description: "We'll email the moment TruCrunch launches." });
    setEmail('');
    setTimeout(() => setSubscribed(false), 6000);
  };

  return (
    <div className="bg-[#FFF4E6] min-h-screen">
      <Navbar />
      <section className="px-5 md:px-8 pt-28 pb-16 relative overflow-hidden">
        <div className="max-w-6xl mx-auto">
          {/* Sneak peek — upcoming products */}
          <div data-testid="upcoming-products-section">
            <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
              <div>
                <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">First on the shelf</div>
                <h1 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">Sneak peek.</h1>
              </div>
              <div className="flex flex-col items-start md:items-end gap-2">
                <p className="font-brico text-sm max-w-xs opacity-70 md:text-right">Just the packaging designs for now — the crunch is still in the kitchen. ₹20 · 30g packs.</p>
                <div className="flex flex-wrap gap-2">
                  <Link to="/play" className="btn-chunky primary text-xs">
                    <Gamepad2 size={14} /> Play · Win a hamper
                  </Link>
                  <a href="#notify" className="btn-chunky outline text-xs">
                    <Bell size={14} /> Notify me
                  </a>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
              {upcomingProducts.map((p) => (
                <UpcomingProductCard key={p.id} product={p} />
              ))}
            </div>
          </div>

          {/* Notify form */}
          <div id="notify" className="mt-14 bg-white rounded-3xl crunch-shadow p-6 md:p-10">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Be first in line</div>
                <h3 className="font-display text-3xl md:text-4xl uppercase mt-2 leading-[0.95]">Be the first bite.</h3>
                <p className="font-brico mt-3 opacity-70">Drop your email and we'll ping you the second the shop opens. No spam — just crunch.</p>
              </div>
              <form onSubmit={notify} className="space-y-3">
                <input
                  required
                  type="email"
                  placeholder="you@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 rounded-2xl border-2 border-[#1a1a1a] font-brico bg-white focus:outline-none focus:ring-2 focus:ring-[#E63946]"
                />
                <button type="submit" className="btn-chunky primary w-full justify-center">
                  {subscribed ? <><CheckCircle2 size={16} /> Added to the list</> : <><Bell size={16} /> Notify me</>}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Shop;
